import React from "react";
import { useLocation } from "react-router-dom";
import Seo from "./Seo";

/**
 * Site-wide default SEO, rendered once in the public layout. It gives EVERY
 * public route a clean, self-referencing canonical + a sensible default
 * title/description. Pages that render their own <Seo> simply override these
 * (react-helmet-async de-duplicates; the deeper, page-level instance wins).
 */

const DEFAULT_DESCRIPTION =
  "Bestowal Systems and Services Pvt. Ltd. delivers custom software development, web & mobile apps, SAP consulting & staffing, cloud, AI/ML, RPA and digital transformation services for enterprises across industries.";

// Share image for pages that don't set their own (index.html's static og:image
// is replaced by helmet once JS runs, so it must come from here too).
const DEFAULT_IMAGE = "/logo512.png";

const DefaultSeo = () => {
  const { pathname } = useLocation();
  return <Seo description={DEFAULT_DESCRIPTION} path={pathname} image={DEFAULT_IMAGE} />;
};

export default DefaultSeo;
